import api from '../services/api';
import { isAccessTokenValid } from './AuthController';

export const getAllTherapyMaterial = async (lang) => {
    try {
        await isAccessTokenValid();
        const response = await api.get('/therapy-material', { params: { lang: lang } });
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const getTherapyMaterialByID = async (id) => {
    try {
        await isAccessTokenValid();
        const response = await api.get(`/therapy-material/${id}`);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const createTherapyMaterial = async (data) => {
    try {
        await isAccessTokenValid();
        const response = await api.post('/therapy-material', data);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const updateTherapyMaterial = async (id, data) => {
    try {
        await isAccessTokenValid();
        const response = await api.put(`/therapy-material/${id}`, data);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const deleteTherapyMaterial = async (id) => {
    try {
        await isAccessTokenValid();
        const response = await api.delete(`/therapy-material/${id}`);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};
